import { ReactNode } from 'react';
import Card from './Card';
import Skeleton from './Skeleton';

interface StatWidgetProps {
  title: string;
  value: string | number;
  icon: ReactNode;
  color: 'blue' | 'green' | 'orange' | 'gray';
  isLoading?: boolean;
}

const colorClasses = {
  blue: 'bg-blue-50 border-blue-200 text-blue-600',
  green: 'bg-green-50 border-green-200 text-green-600',
  orange: 'bg-orange-50 border-orange-200 text-orange-600',
  gray: 'bg-gray-50 border-gray-200 text-gray-600',
};

export default function StatWidget({ title, value, icon, color, isLoading }: StatWidgetProps) {
  return (
    <Card className="p-4 md:p-6">
      <div className="flex flex-col md:flex-row md:items-center justify-between space-y-3 md:space-y-0">
        <div className="flex-1">
          <p className="text-[10px] md:text-sm font-bold uppercase tracking-wider text-gray-500 mb-1">{title}</p>
          {isLoading ? (
            <Skeleton className="h-8 w-16 md:w-20 rounded-lg" />
          ) : (
            <p className="text-2xl md:text-3xl font-extrabold text-gray-900 tracking-tight">{value.toLocaleString()}</p>
          )}
        </div>
        <div className={`w-fit p-2 md:p-3 rounded-xl border-2 ${colorClasses[color]} shadow-sm`}>
          {icon}
        </div>
      </div>
    </Card>
  );
}

